export default __webpack_public_path__ + "static/media/Giveaway.fbaf84d8.mp4";